<!-- mainNavigator -->
<template>
  <div>
      <section class="nav-wrap">
          <nav>
          <ul>
              <li :class="{active:navIndex==0}" @click="menuChange($event,0)"><i :class="{icon:true,active:navIndex==0}"></i><span><router-link to="/">首页</router-link></span></li><i></i>
              <li :class="{active:navIndex==item.id}" @click="menuChange($event,item.id)" v-for="(item,index) in navList"><router-link :to="'/category?id='+item.id">{{item.name}}</router-link></li>
          </ul>
      </nav>
      </section>     
  </div>
</template>

<script>
export default {
  data() {
    return {
      navList: []
    };
  },
  computed: {
    navIndex: {
      get: function() {
        return this.currentIndex;
      },
      set: function() {}
    }
  },
  created() {
    this.getNavList();
  },
  mounted() {},
  props: ["currentIndex"],
  methods: {
    getNavList: function() {
      let that = this;
      that.$axios
        .post(
          "http://imgurl120.moontion.cn/cyy/wy/employ/index.php/Employ/getParentCateInfo"
        )
        .then(res => {
          if (res.data.success) {
            var list = res.data.info;
            that.navList = list;
          }
        });
    },
    menuChange: function(event, current) {
      let that = this;
      that.navIndex = current;
      if (current == 0) {
        that.$router.push({ path: "/" });
      }
      console.log("current", current);
      console.log("navIndex", that.navIndex);
    }
  }
};
</script>
<style scoped>
.nav-wrap {
  width: 1200px;
  height: 70px;
  background: #fff;
  margin: 0 auto;
}
nav {
  padding-top: 20px;
  border-bottom: 2px solid #00a0e9;
}

nav ul > li {
  width: 105px;
  height: 48px;
  box-sizing: border-box;
  list-style: none;
  display: inline-block;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
  color: #333;
}
nav ul > li > a {
  color: #333;
}
nav ul > li.active {
  background: #00a0e9;
}
nav ul > li.active a {
  color: #fff;
}
nav ul li > .icon {
  display: inline-block;
  margin-right: 5px;
  width: 15px;
  height: 15px;
  background-size: 15px 15px;
  background: url("../assets/index.png") left center no-repeat;
}
nav ul li > .icon.active {
  background: url("../assets/index-active.png") left center no-repeat;
}
nav ul {
  font-size: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/MainNavigator.vue